import { HStack, Button, Text, NativeSelect } from '@chakra-ui/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import type { PaginatedResponse, SurveyQuestionSummaryDto } from '../../types/survey'

interface SurveySearchPaginationProps {
  data: PaginatedResponse<SurveyQuestionSummaryDto>
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export function SurveySearchPagination({
  data,
  onPageChange,
  onPageSizeChange,
}: SurveySearchPaginationProps) {
  const { page, pageSize, totalCount, hasNextPage, hasPreviousPage } = data

  const startResult = totalCount === 0 ? 0 : (page - 1) * pageSize + 1
  const endResult = Math.min(page * pageSize, totalCount)

  return (
    <HStack
      justify="space-between"
      p={4}
      bg="surface"
      borderRadius="lg"
      shadow="md"
      flexWrap="wrap"
      gap={4}
    >
      <Text fontSize="sm" color="gray.600">
        Showing {startResult}-{endResult} of {totalCount} results
      </Text>

      <HStack gap={4} flexWrap="wrap">
        <HStack gap={2}>
          <Text fontSize="sm" color="gray.600">
            Per page:
          </Text>
          <NativeSelect.Root size="sm">
            <NativeSelect.Field
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              w="80px">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </NativeSelect.Field>
            <NativeSelect.Indicator />
          </NativeSelect.Root>
        </HStack>

        <HStack gap={2}>
          <Button
            size="sm"
            onClick={() => onPageChange(page - 1)}
            disabled={!hasPreviousPage}
            variant="outline"><FiChevronLeft />Previous
                      </Button>

          <Text fontSize="sm" color="gray.600" px={2}>
            Page {page} of {data.totalPages}
          </Text>

          <Button
            size="sm"
            onClick={() => onPageChange(page + 1)}
            disabled={!hasNextPage}
            variant="outline">Next
                      <FiChevronRight /></Button>
        </HStack>
      </HStack>
    </HStack>
  );
}
